class CartNotification extends HTMLElement {
  cartUpdateUnsubscriber = undefined;

  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (!event || !event.cartData) {
        return;
      }
      if (!this.notification || !this.notification.classList.contains('active')) {
        return;
      }
      this.updatePreviewFromCart(event.cartData);
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  updatePreviewFromCart(cartData) {
    if (!this.cartItemKey || !cartData.items) {
      return;
    }
    const item = cartData.items.find((entry) => entry.key === this.cartItemKey);
    if (!item || !item.properties) {
      return;
    }
    const previewThumb = item.properties['_preview_image_thumbnail_url'] || item.properties['_preview_image_url'];
    if (!previewThumb) {
      return;
    }
    const image = this.querySelector(
      `#cart-notification-product-${this.cartItemKey} .cart-notification-product__image img`
    );
    if (!image) {
      return;
    }
    if (image.getAttribute('src') === previewThumb) {
      return;
    }
    image.removeAttribute('srcset');
    image.setAttribute('src', previewThumb);
    const altText = item.product_title || item.title;
    if (altText) {
      image.setAttribute('alt', altText);
    }
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
